module.exports = __webpack_public_path__ + "static/media/Order_History.814ca766.svg";